import React from 'react';

import {CheckboxSkeleton, FormItemSkeleton, SkeletonItem} from 'src/components/skeleton';

import FormSection from '@pb/kit-component-form-section';
import {Group} from '@pb/kit-component-group';

export const NewsletterSettingsSkeleton = () => {
    return (
        <FormSection headline="Content Settings" info={() => <SkeletonItem width={120} height={28}/>}>
            <FormItemSkeleton labelWidth={70}>
                <Group direction="v" alignItems="start">
                    <Group direction="v" gap="xs">
                        <CheckboxSkeleton labelWidth={50}/>
                        <SkeletonItem width={300} height={32}/>
                    </Group>
                    <CheckboxSkeleton labelWidth={50}/>
                </Group>
            </FormItemSkeleton>
        </FormSection>
    );
};
